import React from 'react';
import './bookViewer.styles.css';

var bookUrl = '';

function openNewPage(){
    window.open(bookUrl, '_blank', 'location=yes,innerHeight=500,innerWidth500,scrollbars=yes,status=yes');
  }

export const PDFViewerComponent = props => {
    bookUrl = props.bookToViewLink;
    return (
        <div>
            <input className='timeTableButton' id='timeTableButton' type='button' value='download file' onClick={openNewPage}/>
            <br/><br/>      
            <div className='bookViewer-container '>
            <iframe src={bookUrl} width="100%" height="500px">
            </iframe>
    
            {/* <embed
                src= { props.bookToViewLink } // 'link'} 
                type="application/pdf"
                frameBorder="0"
                scrolling="auto"
                height="100%"
                width="100%"
            ></embed> */}
            </div>
        </div>
        
    );
    
        
}
